/** @jsxImportSource @emotion/react */
import { EuiResizableContainer } from "@inscopix/ideas-eui";
import { useResizablePanels } from "components/Project/useResizablePanels";
import { useDataTableContext } from "../store/DataTableProvider";
import { ReactNode } from "react";
import { css } from "@emotion/react";
import { FlyoutDrsFileInfoGeneric } from "components/FlyoutDrsFileInfo/FlyoutDrsFileInfoGeneric";
export interface ProjectPageContentProps {
  children: ReactNode;
}
export const ProjectPageContent = (props: ProjectPageContentProps) => {
  const setSelectedFileId = useDataTableContext((s) => s.setSelectedFileId);
  const selectedFileId = useDataTableContext((s) => s.selectedFileId);
  const isRightFlyoutOpen = selectedFileId !== undefined;
  const { panels, handlePanelWidthChange } = useResizablePanels({
    isBottomFlyoutOpen: false,
    isRightFlyoutOpen,
  });

  return (
    <EuiResizableContainer
      direction="horizontal"
      onPanelWidthChange={handlePanelWidthChange}
      style={{ width: "100%", height: "100%" }}
    >
      {(EuiResizablePanel, EuiResizableButton) => {
        const children = [
          <EuiResizablePanel
            key={panels.MAIN_AND_FLYOUT_BOTTOM.id}
            id={panels.MAIN_AND_FLYOUT_BOTTOM.id}
            panelRef={panels.MAIN_AND_FLYOUT_BOTTOM.ref}
            size={panels.MAIN_AND_FLYOUT_BOTTOM.size}
            paddingSize="none"
          >
            <EuiResizableContainer
              direction="vertical"
              onPanelWidthChange={handlePanelWidthChange}
              style={{ width: "100%", height: "100%" }}
            >
              {(EuiResizablePanel, EuiResizableButton) => {
                const children = [
                  <EuiResizablePanel
                    key={panels.MAIN.id}
                    id={panels.MAIN.id}
                    panelRef={panels.MAIN.ref}
                    size={panels.MAIN.size}
                    paddingSize="none"
                    css={css`
                      max-block-size: calc(
                        100vh - var(--euiFixedHeadersOffset, 0)
                      );
                      display: flex;
                      flex-direction: column;
                    `}
                  >
                    {props.children}
                  </EuiResizablePanel>,
                ];

                return <>{children}</>;
              }}
            </EuiResizableContainer>
          </EuiResizablePanel>,
        ];

        if (isRightFlyoutOpen) {
          children.push(
            <EuiResizableButton key="outer-resizer" indicator="border" />,
            <EuiResizablePanel
              key={panels.FLYOUT_RIGHT.id}
              id={panels.FLYOUT_RIGHT.id}
              panelRef={panels.FLYOUT_RIGHT.ref}
              size={panels.FLYOUT_RIGHT.size}
              paddingSize="none"
              minSize="300px"
              css={css`
                max-block-size: calc(100vh - var(--euiFixedHeadersOffset, 0));
              `}
            >
              <FlyoutDrsFileInfoGeneric
                drsFile={{ id: selectedFileId }}
                onClose={() => setSelectedFileId(undefined)}
              />
            </EuiResizablePanel>,
          );
        }

        return <>{children}</>;
      }}
    </EuiResizableContainer>
  );
};
